import React, {useState, useEffect} from 'react';
import { motion} from 'framer-motion';
import { Image, Button } from 'react-bootstrap';

import './events.css';
import './responsive.css';




const coffee = require('../assets/images/coffee.png');
const workshop = require('../assets/images/workshop.png');
const workshop2 = require('../assets/images/workshop2.png');
const openMic = require('../assets/images/open-mic.png');
const openmic2 = require('../assets/images/openmic2.png');
const communitylp = require('../assets/images/communitylp.PNG');
const chatlp = require('../assets/images/chatlp.PNG');
const profilelp = require('../assets/images/profilelp.PNG');


const dance = require('../assets/images/dance.png');
const Events = () => {
    return (
        <div className='events-wrapper'>
            <h1 className='events-header'>
                How It Works
                 
            </h1>
            <div className='event'>
                <Image src={communitylp}/>
                <div className='text'>
                    <h2>
                        Community
                    </h2>
                    <p>
                        Find Other Musicans In Your Area
                        
                    </p>
                </div>
            </div>
            <div className='event'>
                <div className='text'>
                    <h2>
                        Connections
                    </h2>
                    <p>
                        Chat And Collaborate On Ideas 
                    </p>
                </div>
                <Image src={chatlp}/>
            </div>
            <div className='event'>
                <Image src={profilelp}/>
                <div className='text'>
                    <h2>
                        Profile
                    </h2>
                    <p>
                        Showcase Your Portfolio  
                    </p>
                </div>
            </div>
        </div>
    );
};


export default Events;